import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLoginDialog } from "@/contexts/LoginDialogContext";

const Login = () => {
  const { user } = useAuth();
  const { openLoginDialog } = useLoginDialog();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate("/feed", { replace: true });
    } else {
      openLoginDialog();
      navigate(-1);
    }
  }, [user, openLoginDialog, navigate]);

  return null;
};

export default Login;
